/* eslint-disable camelcase */
import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'src/api/axiosBaseQuery'
import { API_BASE_PATH } from 'src/utils/constants'
import {
  CategoriesResponse,
  PaginationPayload,
  ProductI,
  ProductListResponse,
  TransactionResponse,
  UpdateProductPayload,
} from './types'

const API_ENDPOINT = '/api/v1/store'

const manageProductsApi = createApi({
  reducerPath: 'manageProductsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_PATH,
  }),
  tagTypes: ['manageProductsApi'],
  endpoints: (builder) => ({
    getProductsByType: builder.query<ProductListResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '', type }) => ({
        url: `${API_ENDPOINT}/store_items/?item_type=${type}&q=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&sort_by=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
    }),

    getCategoriesByType: builder.query<CategoriesResponse, string>({
      query: (type) => ({
        url: `${API_ENDPOINT}/supplement_types/?type=${type}`,
        method: 'GET',
      }),
    }),

    addProduct: builder.mutation<void, FormData>({
      query: (data) => ({
        url: `${API_ENDPOINT}/admin_product/`,
        method: 'POST',
        data: data,
      }),
    }),

    deleteProduct: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_product/${id}/`,
        method: 'DELETE',
      }),
    }),

    getProductById: builder.query<ProductI, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_product/${id}/`,
        method: 'GET',
      }),
    }),

    updateProduct: builder.mutation<void, UpdateProductPayload>({
      query: ({ data, id }) => ({
        url: `${API_ENDPOINT}/admin_product/${id}/`,
        method: 'PATCH',
        data: data,
      }),
    }),

    getProductsTransactionByType: builder.query<TransactionResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '', type }) => ({
        url: `${API_ENDPOINT}/admin_orders/?item_type=${type}&q=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&sort_by=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetProductsByTypeQuery,
  useAddProductMutation,
  useDeleteProductMutation,
  useGetCategoriesByTypeQuery,
  useGetProductByIdQuery,
  useUpdateProductMutation,
  useLazyGetCategoriesByTypeQuery,
  useGetProductsTransactionByTypeQuery
} = manageProductsApi
export default manageProductsApi
